module.exports = __webpack_public_path__ + "static/media/reflow-sticky4.d2733b68.png";